module.exports = __webpack_public_path__ + "static/img/statistics-2.25ad9a86.png";